export const useIsMatchFinished = (match) => {
  if (!match) return false
  const now = new Date()
  const parseDate = (dateStr) => {
    const [day, month, year] = dateStr.split('.')
    return new Date(`${year}-${month}-${day}`)
  }

  if (!match.game_time) {
    // If no match time, match is finished if today is after match date
    const matchDate = parseDate(match.date)
    // Compare only date part
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    return today > matchDate
  } else {
    // If match time exists, match is finished if now is at least 2 hours after match time
    const [day, month, year] = match.date.split('.')
    const [hour, minute] = match.game_time.split(':').map(Number)
    const matchDateTime = new Date(year, month - 1, day, hour || 0, minute || 0)
    const matchEnd = new Date(matchDateTime.getTime() + 2 * 60 * 60 * 1000)
    return now > matchEnd
  }
}
